import React from 'react'
import PropTypes from 'prop-types'
// import { Box, Stack, Typography } from '@mui/material'
import inxitsLogo from 'assets/images/inxitsLogo.svg'
import bseLogo from 'assets/bselogo.png'
import arrowLoader from 'assets/arrowloader.gif'
import Box from 'components/mui/AppBoxComponent'
import Stack from 'components/mui/Stack'
import Typography from 'components/mui/AppTypographyComponent'

/**
 * Redirecting Component - Shows redirecting screen with logos and loading animation
 * @component
 * @param {Object} props - Component props
 * @param {string} props.title - Main redirecting title (default: "Redirecting ...")
 * @param {string} props.message - Instructional message below title
 * @param {boolean} props.showLogos - Whether to show logos (default: true)
 * @param {string} props.backgroundColor - Background color (default: '#1A1F33')
 * @returns {React.ReactElement} RedirectingComponent
 */
const RedirectingComponent = ({
    title = "Redirecting ...",
    message = "Please wait while we securely take you to our partner portal to cancel your payment.",
    showLogos = true,
    backgroundColor = '#1A1F33'
}) => {
    return (
        <Box
            sx={{
                width: '100%',
                height: '100vh',
                backgroundColor: backgroundColor,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                // padding: 3,
                position: 'relative'
            }}
        >
            {/* Logos Section */}
            {showLogos && (
                <Stack
                    direction="row"
                    alignItems="center"
                    spacing={1}
                    sx={{ mb: 4, height: '123px' }}
                >
                    {/* Inxits Logo */}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            // gap: 1
                        }}
                    >
                        <img
                            src={inxitsLogo}
                            alt="Inxits Logo"
                            style={{
                                height: '100%',
                                width: '187px'
                            }}
                        />
                    </Box>

                    {/* Arrow Loader */}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <img
                            src={arrowLoader}
                            alt="Loading..."
                            style={{
                                height: '100%',
                                width: '182px'
                            }}
                        />
                    </Box>

                    {/* BSE Logo */}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1
                        }}
                    >
                        <img
                            src={bseLogo}
                            alt="BSE Logo"
                            style={{
                                height: '100%',
                                width: '202px'
                            }}
                        />
                    </Box>
                </Stack>
            )}

            {/* Main Title */}
            <Typography
                variant="h4"
                sx={{
                    color: 'white',
                    fontSize: 32,
                    fontWeight: 600,
                    textAlign: 'center',
                    mb: 2,
                    letterSpacing: '0.5px'
                }}
            >
                {title}
            </Typography>

            {/* Instructional Message */}
            <Typography
                variant="body1"
                sx={{
                    color: 'white',
                    fontSize: 24,
                    fontWeight: 400,
                    textAlign: 'center',
                    maxWidth: '500px',
                    lineHeight: 1.5,
                    // opacity: 0.9
                }}
            >
                {message}
            </Typography>
        </Box>
    )
}

RedirectingComponent.propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,
    showLogos: PropTypes.bool,
    backgroundColor: PropTypes.string
}

RedirectingComponent.defaultProps = {
    title: "Redirecting ...",
    message: "Please wait while we securely take you to our partner portal to cancel your payment.",
    showLogos: true,
    backgroundColor: '#1A1F33'
}

export default RedirectingComponent
